import React, { useEffect, useRef, useState } from 'react'
import classNames from 'classnames'
import GlobalBanner from './Banner/GlobalBanner'
import RegionSwitcherInfoBanner from './RegionSwitcherInfoBanner'
import RegionSwitcher from './RegionSwitcher'
import { usePageContext } from '@toasttab/shared/src/hooks/usePageContext'
import { useScrollPosition } from '@toasttab/shared/src/hooks/useScrollPosition'

const BannerContainer = () => {
  const [bannerMaxHeight, setBannerMaxHeight] = useState('0px')
  const [showTopBanner, setShowTopBanner] = useState(true)

  const bannerRef = useRef<HTMLDivElement>(null)

  const {
    activeRegionSwitcherInfoBanner,
    allEntries,
    headerHeight,
    localizedEntries,
    packageName,
    setHeaderHeight,
    siteId
  } = usePageContext()

  const scrollPosition = useScrollPosition()

  useEffect(() => {
    const showBanner =
      scrollPosition <= 0 &&
      ['main', 'onTheLine'].includes(packageName) &&
      activeRegionSwitcherInfoBanner !== undefined
    if (showBanner !== showTopBanner) {
      setShowTopBanner(showBanner)
    }
  }, [
    activeRegionSwitcherInfoBanner,
    packageName,
    showTopBanner,
    scrollPosition
  ])

  useEffect(() => {
    if (bannerRef.current) {
      requestAnimationFrame(() => {
        if (showTopBanner) {
          setBannerMaxHeight(`${bannerRef.current?.scrollHeight}px`)
        } else {
          setBannerMaxHeight('0px')
        }
      })
    }
    // Re-set headerHeight when banner state changes
    const headHeight =
      typeof document !== 'undefined'
        ? document.querySelector('.headerContent')?.clientHeight
        : 0
    if (headHeight > 0 && headHeight !== headerHeight) {
      setHeaderHeight(headHeight)
    }
  }, [
    activeRegionSwitcherInfoBanner,
    headerHeight,
    setHeaderHeight,
    showTopBanner
  ])

  const topBannerClasses = classNames(
    'transition-all duration-1000 ease-in-out overflow-hidden'
  )
  return (
    <>
      <div
        className={topBannerClasses}
        ref={bannerRef}
        style={showTopBanner ? {} : { maxHeight: bannerMaxHeight }}
      >
        <RegionSwitcherInfoBanner
          localizedEntries={localizedEntries || allEntries}
          packageName={packageName}
          siteId={siteId}
        />
        {/* 
          If the region switcher info banner is false, show the global banner, otherwise show nothing -- 
          this will make sure we are not seeing the flickering of the global banner, when both banners are active
        */}
        {activeRegionSwitcherInfoBanner === false && <GlobalBanner />}
      </div>
      <RegionSwitcher
        localizedEntries={localizedEntries || allEntries}
        packageName={packageName}
        siteId={siteId}
      />
    </>
  )
}

export default BannerContainer
